import fetch from 'services'

import { getCombinables } from './mockdata'

const PAGE_LIMIT = 50

export const getFurniture = ({ region, subCatalog, category, subCategory, roomType, stackEnabled }, page) =>
    fetch('/furniture/', {
        params: {
            region,
            sub_catalogs: subCatalog,
            category_id: category,
            sub_category_id: subCategory,
            room_type: roomType,
            stacks: stackEnabled ? undefined : false,
            limit: PAGE_LIMIT,
            offset: (page - 1) * PAGE_LIMIT,
            geometry_type: '3d,2d_wall',
        },
    })

export const getFurnitureBySearch = ({ query, region, stackEnabled }, moreToken) =>
    fetch('/furniture/search', {
        params: {
            q: query,
            region,
            needMore: 'True',
            moreToken,
            stacks: stackEnabled ? undefined : false,
            geometry_type: '3d,2d_wall',
        },
    })

export const getFurnitureByIds = (ids) =>
    fetch('/furniture/', {
        params: {
            id__in: ids.join(','),
            geometry_type: '3d,2d_wall',
        },
    })

export const getFurnitureByLocalItemNos = (localItemNos) =>
    fetch('/furniture/', {
        params: {
            local_item_number: localItemNos.join(','),
        },
    })

export const getFurnitureCategories = (region, stackEnabled) =>
    fetch('/furniture/categories', {
        params: {
            region,
            stack: stackEnabled ? undefined : false,
            geometry_type: '3d,2d_wall',
        },
    })

export const getFurnitureSwappables = (id) =>
    fetch(`/furniture/${id}/swappables/`, {
        params: {
            geometry_type: '3d,2d_wall',
        },
    })

export const getFurnitureCombinables = (slotCategory, size, variant) => {
    //    fetch(`/furniture/${id}/combinables`, {
    //        params: {
    //        slotCategory,
    //        size,
    //        },
    //    })
    const data = getCombinables(slotCategory, size, variant)
    return {
        data,
    }
}
